"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTemplateDisabled = void 0;
const types_1 = require("@framework/types");
const constants_1 = require("@dzambalaorg/constants");
const types_blockchain_1 = require("@dzambalaorg/types-blockchain");
const isTemplateDisabled = (chainId) => {
    const disabledTemplates = [];
    // These templates have too long code so can be deployed only on private network
    if (!(chainId === Number(types_blockchain_1.Networks.GEMUNION) || chainId === Number(types_blockchain_1.Networks.GEMUNION_BESU))) {
        disabledTemplates.push(types_1.Erc998ContractTemplates.ERC20OWNER, types_1.Erc998ContractTemplates.ERC1155OWNER, types_1.Erc998ContractTemplates.ERC1155OWNER_ERC20OWNER);
    }
    if (process.env.NODE_ENV === constants_1.NodeEnv.production) {
        // Rent (is not tested yet)
        disabledTemplates.push(types_1.Erc998ContractTemplates.RENTABLE);
        // ChainLink
        if (!types_1.ChainLinkV2SupportedChains[chainId]) {
            disabledTemplates.push(types_1.Erc998ContractTemplates.RANDOM, types_1.Erc998ContractTemplates.DISCRETE_RANDOM, types_1.Erc998ContractTemplates.BLACKLIST_DISCRETE_RANDOM, types_1.Erc998ContractTemplates.BLACKLIST_RANDOM);
        }
    }
    return disabledTemplates;
};
exports.isTemplateDisabled = isTemplateDisabled;
//# sourceMappingURL=utils.js.map